import $ from 'jquery';

const SHOPIFY_SCRIPT_URL = '/scripts/dist/buybutton.js' //'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';

const PURPLE_HOVER_FOCUS_COLOR = '#160028';
const SUPERNOVA_HOVER_FOCUS_COLOR = '#FFCA00';
const PURPLE_COLOR = '#00003f';
const ORANGE_COLOR = '#FF7F00';
const GREEN_COLOR = '#00ff00';

const LABEL_ADD_PRODUCT = 'labelAddProduct';
const LABEL_ADD_TO_CART = 'labelAddToCart';
const LABEL_CART = 'labelCart';
const LABEL_TOTAL = 'labelTotal';
const LABEL_EMPTY_CART = 'labelEmptyCart';
const LABEL_NOTICE = 'labelNotice';
const LABEL_PAY = 'labelPay';

const LABELS_SWEDISH = {}
LABELS_SWEDISH[LABEL_ADD_PRODUCT] ='Lägg till produkt';
LABELS_SWEDISH[LABEL_ADD_TO_CART] ='Lägg till i varukorgen';
LABELS_SWEDISH[LABEL_CART] ='Varukorg';
LABELS_SWEDISH[LABEL_TOTAL] ='Summa';
LABELS_SWEDISH[LABEL_EMPTY_CART] ='Din varukorg är tom';
LABELS_SWEDISH[LABEL_NOTICE] ='Frakt och rabatter läggs till i slutet.';
LABELS_SWEDISH[LABEL_PAY] ='Betala';

const LABELS_ENGLISH = {};
LABELS_ENGLISH[LABEL_ADD_PRODUCT] ='Add product';
LABELS_ENGLISH[LABEL_ADD_TO_CART] ='Add to cart';
LABELS_ENGLISH[LABEL_CART] ='Cart';
LABELS_ENGLISH[LABEL_TOTAL] ='Amount';
LABELS_ENGLISH[LABEL_EMPTY_CART] ='Your cart is empty';
LABELS_ENGLISH[LABEL_NOTICE] ='Shipping and discounts are added at the end.';
LABELS_ENGLISH[LABEL_PAY] ='Pay';

const TRANSLATIONS = {
    'en-GB': LABELS_ENGLISH,
    'sv-SE': LABELS_SWEDISH
}

export default class ProductInfoHandler {
    constructor() {
        this.init();
    }

    init() {
        if ($('[data-product-id]').length > 0) {
            if (window.ShopifyBuy && window.ShopifyBuy.hasOwnProperty('UI')) {
                this.ShopifyBuyInit();
            } else {
                this.loadShopifyScript();
            }
        }
    }

    loadShopifyScript() {
        var assetsPath = $('body').data('assetsPath');
        var script = document.createElement('script');
        script.async = true;
        script.src = assetsPath + SHOPIFY_SCRIPT_URL;
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
        script.onload = this.ShopifyBuyInit;
        console.log(this.ShopifyBuyInit);
    }

    ShopifyBuyInit() {
        window.client = ShopifyBuy.buildClient({
            domain: 'acceleratorsu.myshopify.com',
            storefrontAccessToken: '059ea6998f48d3727e6ad812ee955cf1',
        });

        window.ui = ShopifyBuy.UI.init(client);
        var $shopifyContainers = $('[data-product-id]');
        $shopifyContainers.each(function () {
            var $container = $(this);
            var lang = $('html').attr('lang');
            var labels = TRANSLATIONS[lang];
            console.log(labels);
            var orderFieldLabel = $container.data('orderFieldLabel');
            var orderFieldName = $container.data('orderFieldName');

            var options = {
                "product": {
                    "styles": {
                        "product": {
                            "@media (min-width: 601px)": {
                                "margin-bottom": "50px"
                            },
                            "text-align": "left"
                        },
                        "button": {
                            "font-weight": "600",
                            "font-size": "20px",
                            "line-height": "1.15",
                            "background-color": ORANGE_COLOR,
                            ":hover": {
                                "background-color": SUPERNOVA_HOVER_FOCUS_COLOR
                            },
                            ":focus": {
                                "background-color": SUPERNOVA_HOVER_FOCUS_COLOR,
                            },
                            "color": PURPLE_HOVER_FOCUS_COLOR,
                            "border-radius": "0px",
                            "padding": "20px",
                            "width": "100%",
                            "transition": "all 0.3s ease",
                            "@media (min-width: 401px)": {
                                "max-width": "280px",
                                "margin": "0 auto"
                            }
                        },

                    },
                    "contents": {
                        "img": false,
                        "title": false,
                        "price": false,
                        "note": true,
                    },
                    order: [
                        'price',
                        'note',
                        'button',
                    ],
                    "text": {
                        "button": labels[LABEL_ADD_PRODUCT]
                    }
                },
                "productSet": {
                    "styles": {
                        "products": {
                            "@media (min-width: 601px)": {
                                "margin-left": "-20px"
                            }
                        }
                    }
                },
                "modalProduct": {
                    "contents": {
                        "img": false,
                        "imgWithCarousel": true,
                        "button": false,
                        "buttonWithQuantity": true
                    },
                    "styles": {
                        "product": {
                            "@media (min-width: 601px)": {
                                "max-width": "100%",
                                "margin-left": "0px",
                                "margin-bottom": "0px"
                            }
                        },
                        "button": {
                            "font-weight": "bold",
                            ":hover": {
                                "background-color": PURPLE_HOVER_FOCUS_COLOR
                            },
                            "background-color": PURPLE_COLOR,
                            ":focus": {
                                "background-color": PURPLE_HOVER_FOCUS_COLOR
                            },
                            "border-radius": "0px"
                        }
                    },
                    "text": {
                        "button":  labels[LABEL_ADD_TO_CART]
                    }
                },
                "cart": {
                    "styles": {
                        "button": {
                            "font-weight": "bold",
                            ":hover": {
                                "background-color": PURPLE_HOVER_FOCUS_COLOR
                            },
                            "background-color": PURPLE_COLOR,
                            ":focus": {
                                "background-color": PURPLE_HOVER_FOCUS_COLOR
                            },
                            "border-radius": "0px"
                        }
                    },
                    "text": {
                        "title": labels[LABEL_CART],
                        "total": labels[LABEL_TOTAL],
                        "empty": labels[LABEL_EMPTY_CART],
                        "notice": labels[LABEL_NOTICE],
                        "button": labels[LABEL_PAY]
                    }
                },
                "toggle": {
                    "styles": {
                        "toggle": {
                            "font-weight": "bold",
                            "background-color": PURPLE_COLOR,
                            ":hover": {
                                "background-color": PURPLE_HOVER_FOCUS_COLOR
                            },
                            ":focus": {
                                "background-color": PURPLE_HOVER_FOCUS_COLOR
                            }
                        }
                    }
                },
            };

            if (orderFieldLabel) {
                options['product']['templates'] = {
                    "note": '<div><label for="product_note" class="{{data.classes.product.productNoteLabel}}">'
                        + orderFieldLabel
                        + ': </label><input data-propertyName="'
                        + orderFieldName
                        + '" id="product_note" data-element="product.noteInput" class="{{data.classes.product.productNote}}"></div>'
                }

                options['product']['styles']['productNoteLabel'] = {
                    "font-size": "16px",
                    "line-height": "26px",
                    "font-weight": "500",
                    "color": "#000",
                    "display": "block",
                    "margin-top": "20px"
                };

                options['product']['styles']['productNote'] = {
                    "box-sizing": "border-box",
                    "-webkit-appearance": "none",
                    "border-radius": "0",
                    "width": "100%",
                    "max-width": "380px",
                    "height": "60px",
                    "border": "1px solid #e2e2e2",
                    "padding": "0 20px",
                    "font-size": "18px",
                    "margin": "5px 0 0 0"
                };

                options['lineItem'] = {
                    "contents": {
                        "notes": true,
                    },
                    "templates": {
                        "notes": '{{#data.customAttributes}}<div class="{{data.classes.lineItem.notes}}"><small>'
                            + orderFieldLabel + ' {{value}}</small></div>{{/data.customAttributes}}',
                    },
                    "classes": {
                        "notes": 'lineItem-notes',
                    },
                    "styles": {
                        "notes": {
                            'clear': 'both',
                            'margin-top': '10px',
                        }
                    },
                    "order": [
                        'image',
                        'variantTitle',
                        'title',
                        'price',
                        'quantity',
                        'notes',
                    ],
                }
            }

            ui.createComponent('product', {
                id: $container.data('productId'),
                node: $container.get(0),
                moneyFormat: '%7B%7Bamount_no_decimals%7D%7D%20kr',
                options: options,
            });
        });
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/Blocks/ProductInfoHandler.js